import { render, staticRenderFns } from "./TalkThreadChats.vue?vue&type=template&id=1b27a9af&"
import script from "./TalkThreadChats.vue?vue&type=script&lang=ts&"
export * from "./TalkThreadChats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports